// UnderConstruction.tsx

import React from 'react';
import { Typography, Container, Box } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
// Or use <a href="/">Startseite</a> if not using router

export const UnderConstruction: React.FC = () => {
	return (
		<Box sx={{ bgcolor: '#FAFAFB' }}>
			<Container
				maxWidth="sm"
				sx={{
					height: '100vh',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					textAlign: 'center',
					gap: 4,
				}}
			>
				<ConstructionIcon sx={{ fontSize: 80, color: 'warning.main' }} />
				<Typography variant="h4" fontWeight="bold">
					Diese Seite befindet sich im Aufbau
				</Typography>
				<Typography variant="body1" color="text.secondary">
					Wir arbeiten daran, diese Seite so schnell wie möglich verfügbar zu machen.
					Vielen Dank für Ihre Geduld!
				</Typography>

				<a
					href="/"
				>
					Zurück zur Startseite
				</a>
			</Container>
		</Box>
	);
};
